import { RedesVamEntity } from "../../../vam/vam_entity";

export class RedesEmpresa {
    constructor(
        public nombrePlan?: string,
        public redesVamEntity?: RedesVamEntity[]
    ){}
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/redes/redes_entity.ts